export const  formatPhoneNumber = (phone) => {
    return phone.toString().replace(/\D/g, '');
}

export const forceLoutAction = (force)=>{
    let action =  (force === null) || (force === undefined) || (force === "") ? true : false; 
    return action
}


export function format(value,length) {
    if (typeof value !== 'string' || value.trim() === '') {
        return 'Unknown';
    }
    const fullName =  value.charAt(0).toUpperCase() + value.slice(1);
    return reduceLength(fullName,length);
  }

  const reduceLength = (value,length) => {
    if (typeof value !== 'string') {
      return "";
    }
    return value.length > length ? value.slice(0, length) + '...' : value;
  };